import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

interface LoadingState {
  count: number;
}

const initialState: LoadingState = {
  count: 0,
};

export const LoadingService = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    isLoading: computed(() => store.count() > 0),
  })),
  withMethods((store) => ({
    show(): void {
      patchState(store, { count: store.count() + 1 });
    },
    hide(): void {
      patchState(store, { count: Math.max(0, store.count() - 1) });
    },
    reset(): void {
      patchState(store, { count: 0 });
    },
  }))
);
